<template>
  <div>{{ menuList }}</div>
</template>

<script>
// import * as ecAxios from '@/util/ecAxios';

export default {
	name: 'Menu',
	data() {
		return {
			menuList: [],
			loadingMenuList: false,
		};
	},
	beforeMount() {
		this.getMenuList();
	},
	methods: {
		async getMenuList() {
			this.loadingMenuList = true;

			try {
				this.menuList = [
					{
						title: 'Ínicio',
						name: 'Home',
						icon: 'home',
						isRotate: false,
						children: [
							{
								title: 'Analytics',
								name: 'Analytics',
								icon: 'home',
								active: false, // Sempre usar essa tah ou não aparece o menu
							},
						],
					},
					{
						title: 'Clientes ',
						name: 'Clientes',
						icon: 'users',
						isRotate: false,
						children: [
							{
								title: 'Usuários',
								name: 'Usuarios',
								icon: 'user',
								active: false,
							},
							{
								title: 'Cadastro',
								name: 'PreCadastro',
								icon: 'user-plus',
								active: false,
							},
						],
					},
					{
						title: 'Pedidos',
						name: 'Pedidos',
						icon: 'file-text',
						active: false,
					},
					{
						title: 'Pagamento Cartão',
						name: 'PagamentoCartao',
						icon: 'credit-card',
						active: false,
					},
					{
						title: 'Relatórios',
						name: 'Relatorios',
						icon: 'clipboard',
						isRotate: false,
						children: [
							{
								title: 'Integrações',
								name: 'Integracoes',
								icon: 'database',
								active: false,
							},
						],
					},
					{
						title: 'Parâmetros de Pedido',
						name: 'Parâmetros de Pedido',
						icon: 'sliders',
						isRotate: false,
						children: [
							{
								title: 'Forma de Pagamento',
								name: 'Forma de Pagamento',
								icon: 'home',
								active: false,
							},
							{
								title: 'Condição de Pagamento',
								name: 'Condição de Pagamento',
								icon: 'home',
								active: false,
							},
							{
								title: 'Tabela de Vendas',
								name: 'Tabela de Vendas',
								icon: 'home',
								active: false,
							},
						],
					},
					{
						title: 'Administração',
						name: 'Administração',
						icon: 'settings',
						isRotate: false,
						children: [
							{
								title: 'Usuários',
								name: 'AdmUsers',
								icon: 'home',
								active: false,
							},
							/*  {
              title: 'Permissões',
              name: 'SettingPermission',
              icon: 'home',
              active: false,
            },
            {
              title: 'Cargos',
              name: 'SettingRole',
              icon: 'home',
              active: false,
            }, */
							{
								title: 'Menus',
								name: 'SettingMenu',
								icon: 'home',
								active: false,
							},
						],
					},
				];
			} catch (e) {
				this.$buefy.notification.open({
					message: e.toString(),
					type: 'is-warning'
				});
			}

			this.loadingMenuList = false;
		},
	},
};
</script>

<style lang="scss" scoped>
</style>
